import { render, staticRenderFns } from "./StringListFlex.vue?vue&type=template&id=3fc0d3dd&"
import script from "./StringListFlex.vue?vue&type=script&lang=js&"
export * from "./StringListFlex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports